import { TaskEventDateIcon } from '@/components/ui';

export interface EventLinkBadgeProps {
  /** The event's title. */
  title: string;
  className?: string;
}

const BASE_CLASSES =
  'inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-info-bg text-info-text text-xs truncate max-w-[180px] border border-info-border';

/**
 * v1.0's blue calendar badge naming the event a task belongs to, extracted
 * from production's review `TaskCard`. Long titles truncate; the full title
 * is the hover text.
 *
 * `className` is appended as given: never pass a utility for a property the
 * base already sets (two utilities for one property resolve by stylesheet
 * order, not by position).
 */
export function EventLinkBadge({ title, className }: EventLinkBadgeProps) {
  return (
    <span
      data-testid="event-link-badge"
      title={title}
      className={className ? `${BASE_CLASSES} ${className}` : BASE_CLASSES}
    >
      <TaskEventDateIcon
        size={12}
        className="flex-shrink-0"
      />
      {title}
    </span>
  );
}
